import React, { useEffect, useRef, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { loadJsQR, startCameraStream, stopCameraStream } from "../utils/media";

// Mở camera + quét QR liên tục -> onDetected(text) (gọi 1 lần)
const QrScanner = ({ onDetected }) => {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const rafRef = useRef(null);
  const detectedRef = useRef(false);
  const [error, setError] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    const canvas = document.createElement("canvas");

    const tick = (jsQR) => {
      if (!active || detectedRef.current) return;
      const video = videoRef.current;
      if (video && video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: "dontInvert",
        });
        if (code?.data) {
          detectedRef.current = true;
          onDetected?.(code.data);
          return;
        }
      }
      rafRef.current = requestAnimationFrame(() => tick(jsQR));
    };

    (async () => {
      try {
        const jsQR = await loadJsQR();
        const stream = await startCameraStream("environment");
        if (!active) {
          stopCameraStream(stream);
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play().catch(() => {});
          setReady(true);
          rafRef.current = requestAnimationFrame(() => tick(jsQR));
        }
      } catch (e) {
        setError(e?.message || "Không mở được camera/QR");
      }
    })();

    return () => {
      active = false;
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      stopCameraStream(streamRef.current);
    };
  }, [onDetected]);

  if (error) {
    return (
      <Box bg="#FFF0F0" color="#EF2E14" p="12px" borderRadius="8px" fontSize="13px">
        {error}
      </Box>
    );
  }

  return (
    <Flex direction="column" gap="10px" align="center">
      <Box
        w="100%"
        maxW="360px"
        borderRadius="12px"
        overflow="hidden"
        bg="black"
        position="relative"
        sx={{ aspectRatio: "1 / 1" }}
      >
        <video
          ref={videoRef}
          playsInline
          muted
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        {/* khung ngắm */}
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          w="60%"
          h="60%"
          border="3px solid rgba(255,255,255,0.85)"
          borderRadius="12px"
        />
      </Box>
      <Text fontSize="12px" color="var(--color-label-employee)">
        {ready ? "Đưa mã QR vào khung để quét" : "Đang khởi động camera..."}
      </Text>
    </Flex>
  );
};

export default QrScanner;
